import { canActor } from '../domain/authorization'
import type { ActorContext } from '../domain/authorization'
import type { NotifyPort } from '@/features/messages/domain/notify'
import type { WorkItem, WorkItemPort } from '../domain/workflow'

const editComment = async (
	port: WorkItemPort,
	item: WorkItem,
	ctx: ActorContext,
	commentId: string,
	body: string,
	notify: NotifyPort,
	phaseTeamId: string | null = null,
): Promise<WorkItem | null> => {
	if (!canActor('comment', item, ctx, phaseTeamId)) {
		notify.error('workItem.denyEditComment')
		return null
	}
	try {
		const updated = await port.editComment(item.id, commentId, body)
		return updated
	} catch {
		notify.error('workItem.commentEditFailed')
		return null
	}
}

export { editComment }
